import { Box, TextField, Typography } from '@mui/material';
import { useModal } from '../../context/ModalProvider/useModal';

export const UploadRequiredDocument = () => {
  const { setValue } = useModal();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Typography sx={{ textAlign: 'center', color: '#655C68' }}>
        Enter the title of the required document in Tax Filing
      </Typography>
      <TextField
        sx={{ width: '100%' }}
        inputProps={{
          style: {
            padding: '8px 12px',
            fontSize: '14px',
          },
        }}
        onChange={(e: any) => setValue(e.target.value)}
      />
    </Box>
  );
};
